'use client';

import { useMemo } from 'react';

import { useKpowHistory, useKpowSnapshot } from 'queries/kpow';
import type { KpowHistoryPoint } from 'react_pages/AmericanPowerIndex/api/kpowApi';
import ChartCard from 'react_pages/AmericanPowerIndex/components/ChartCard';

export default function KpowChartWidget() {
    const snapshotQuery = useKpowSnapshot();
    const historyQuery = useKpowHistory();

    const snapshot = snapshotQuery.data ?? null;

    const points = useMemo<KpowHistoryPoint[]>(() => {
        const historyPoints = historyQuery.data?.points ?? [];
        if (!snapshot) return historyPoints;
        const lastTs = historyPoints[historyPoints.length - 1]?.end_period_ts ?? 0;
        if (snapshot.data_as_of <= lastTs) return historyPoints;

        return [
            ...historyPoints,
            {
                end_period_ts: snapshot.data_as_of,
                signed_value: snapshot.composite.signed_value,
                display_party: snapshot.composite.display_party,
                display_value: snapshot.composite.display_value,
            },
        ];
    }, [historyQuery.data, snapshot]);

    return <ChartCard snapshot={snapshot} points={points} loading={historyQuery.isPending} flexible />;
}
